<template>
<div>

  <el-row :gutter="20">

    <el-col :md="8" :lg="5">
      <el-input placeholder="活动ID" v-model="params.activity_id" clearable><el-button slot="append" icon="el-icon-search" @click="searchLog"></el-button></el-input>
    </el-col>
    <el-col :md="8" :lg="5">
      <el-input placeholder="店铺ID" v-model="params.organizer" clearable><el-button slot="append" icon="el-icon-search" @click="searchLog"></el-button></el-input>
    </el-col>
    <!-- <el-col :md="7" :lg="5">
          <el-select v-model="category_id" @change="searchLog" placeholder="选择主题"
                     style="width: 100%;" size="">
              <el-option
                      v-for="(item, index) in category"
                      :key="index"
                      :label="item.category_name"
                      :value="item.id">
              </el-option>
          </el-select>
      </el-col> -->
      <el-col :md="10" :lg="8">
          <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size=""></el-date-picker>
      </el-col>
    <el-button type="primary" @click="exportDataA"> 导出数据</el-button>

  </el-row>
      <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="报名信息" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="activity_id" label="活动id"></el-table-column>
        <el-table-column prop="user_name" label="用户名"></el-table-column>
        <el-table-column prop="mobile" label="用户手机"></el-table-column>
        <el-table-column prop="organizer" label="主办单位"></el-table-column>
        <el-table-column prop="date_time" label="报名时间">
          <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="to_store_time" label="到店时间">
          <template slot-scope="scope">
              <span v-if="scope.row.to_store_time==null ">未扫到店码</span>
              <span v-else-if="scope.row.to_store_time != null">
                  {{scope.row.to_store_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>

          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="支付单号">
        </el-table-column>
        <el-table-column prop="mark" label="备注">
        </el-table-column>
      </el-table>
      <div  class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
      </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {getDistributorselfActivityLog,exportDistributorActivityLog,getDistributorActivityCategoryList} from '../../../../api/marketing'

    export default {
        data () {
            return {
                clickable:false,
                dialog: false,
                activeName: 'admin',
                list: [],
                category_id:'',
                total_count: 0,
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    activity_id:'',
                    organizer:'',
                    time_start_begin:'',
                    time_start_end:'',
                },
                create_time:'',
                category:[],
                time_start_begin:'',
                time_start_end:'',
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {

            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.getList()
            },
            searchLog () {
                this.params.page = 1
                this.getList()
            },

            dateChange (val) {
                if (val.length > 0) {
                    this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.time_start_begin = ''
                    this.time_start_end = ''
                }
                this.params.page = 1

                this.getList(this.params)
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            getList () {
                this.loading = true
                if(this.$route.query.activity_id) {
                    this.params.activity_id = this.$route.query.activity_id
                }
                this.params.category_id = this.category_id
                this.params.time_start_begin = this.time_start_begin
                this.params.time_start_end = this.time_start_end
                getDistributorselfActivityLog(this.params).then(response => {
                    if(response.data.data.list) {
                        // console.log(response.data.data.list)
                        this.list = response.data.data.list
                        this.total_count = Number(response.data.data.total_count)

                    }
                    this.loading = false
                })
            },
            getAllCategory(){
                getDistributorActivityCategoryList().then(response=>{
                    this.category = response.data.data.list
                })
            },
            exportDataA(){
              // 导出数据
                exportDistributorActivityLog(this.params).then(response => {
                    //console.log(response.data)
                    if(response.data) {
                        var a = document.createElement('a')
                        a.href = response.data.url
                        a.download = response.data.filename
                        a.click()
                    }
                })
            },
        },
        mounted () {
            this.getAllCategory()
            this.getList()
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// log.vue?235dc08f